import { useParams } from 'react-router-dom';
import SPKCandidateList from '$components/SPKCandidateList/SPKCandidateList';
import { useGetSharedCandidatesRosterDataQuery } from '$store/modules/candidates';
import SPKCardSkeleton from '$components/SPKCardSkeleton/SPKCardSkeleton';
import SPKShareTitle from '$components/Share/SPKShareTitle';
import { useSyncCurrencyFromUrl } from '$hooks/useSyncCurrencyFromUrl';

const ShareCandidates = () => {
  const { shareCandidatesIds } = useParams();
  useSyncCurrencyFromUrl();

  const {
    data: sharedRosterData,
    isLoading,
    error,
  } = useGetSharedCandidatesRosterDataQuery({
    sharedRosterId: shareCandidatesIds as string,
  });

  return (
    <div data-testid="shareCandidatesPage" className="pb-8 font-mulish">
      <div className="flex flex-col gap-4">
        {isLoading && (
          <div className="h-full mt-2 flex flex-col gap-4">
            <SPKCardSkeleton
              height="h-12"
              className="flex-grow bg-[#EBE8DD] rounded-2xl mb-4"
            />
            {Array.from({ length: 5 }).map((_, index) => (
              <SPKCardSkeleton
                // eslint-disable-next-line react/no-array-index-key
                key={`CardSkeleton_${index}`}
                height="h-56"
                className="flex-grow bg-[#EBE8DD] rounded-2xl"
              />
            ))}
          </div>
        )}
        {error && <div className="m-auto">Invalid Request</div>}

        {!isLoading && sharedRosterData && (
          <>
            <SPKShareTitle jobTitle={sharedRosterData?.positionName} />
            <SPKCandidateList
              candidates={sharedRosterData.candidates}
              shareCandidatesIds={shareCandidatesIds as string}
              feeAmount={sharedRosterData.fee}
              shortlistTitle={sharedRosterData.positionName}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default ShareCandidates;
